import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { ZodExtended } from "@/data/zod.extended";
import { WatchlistModels } from "./watchlist.models";

export namespace WatchlistApi {
export const getJobFits = () => { 
    return AppRestClient.get( 
        { resSchema: WatchlistModels.WatchlistJobFitListResponseDtoSchema }, 
        `/watchlist/jobs/job-fits`,
        
    )
};

export const calculateJobFit = (data: WatchlistModels.CalculateJobFitDto, ) => { 
    return AppRestClient.post( 
        { resSchema: WatchlistModels.WatchlistJobFitFindByTitleResponseDtoSchema }, 
        `/watchlist/jobs/calculate-job-fit`,
        ZodExtended.parse(WatchlistModels.CalculateJobFitDtoSchema, data)
, 
        
    )
};

export const findJobFitByTitle = (data: WatchlistModels.FindJobFitByTitleDto, ) => { 
    return AppRestClient.post( 
        { resSchema: WatchlistModels.WatchlistJobFitFindByTitleResponseDtoSchema }, 
        `/watchlist/jobs/job-fit/find-by-title`,
        ZodExtended.parse(WatchlistModels.FindJobFitByTitleDtoSchema, data)
, 
        
    )
};

}
